import request from "react-rb/request"

/**
 * Get pricing table data for the account.
 *
 * @return {Promise<PricingTableResponse>} The pricing table data
 */
export async function getPricingTableData({ promoCode } = {}) {
  const params = new URLSearchParams()
  if (promoCode) params.set("promo_code", promoCode)

  const response = await request(
    `/billing/pricing_display/table${params.size ? `?${params}` : ""}`,
    {
      method: "GET"
    }
  )
  if (!response.ok) throw response
  return response.data
}

/**
 * Get plan comparison data for the account.
 *
 * @return {Promise<PlanComparisonResponse>} The plan comparison data
 */
export async function getPlanComparisonData({ promoCode } = {}) {
  const params = new URLSearchParams()
  if (promoCode) params.set("promo_code", promoCode)

  const response = await request(
    `/account/billing/plan_comparison${params.size ? `?${params}` : ""}`,
    {
      method: "GET"
    }
  )
  if (!response.ok) throw response
  return response.data
}

/**
 * Switch the account to a different plan.
 *
 * @return {Promise} The response from switching plans
 */
export async function switchPlan({ planId, promoCode }) {
  const data = { plan_id: planId }
  if (promoCode) data.promo_code = promoCode

  const response = await request("/account/billing/switch_plan", {
    method: "PUT",
    data
  })
  if (!response.ok) throw response
  return response.data
}

/**
 * Enable the pro plan for the account.
 *
 * @param {Object} params - The parameters
 * @param {string} params.planId - The plan ID to enable
 * @param {string|null} params.promoCode - Optional promo code
 * @return {Promise} The response from enabling the pro plan
 */
export async function enableProPlan({ planId, promoCode }) {
  const data = {
    account: {
      plan_id: planId,
      promo_code: promoCode || null
    }
  }

  const response = await request("/account/billing/enable_pro_plan", {
    method: "PUT",
    data
  })
  if (!response.ok) throw response
  return response.data
}
